import { AuthService } from '@/services';
import {
  MagicLoginResponse,
  ResetPasswordChallengeResponse,
  SignInPayload,
  SignInResponse,
} from '@/types';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

type MutationSignIn = UseMutationOptions<
  { data: SignInResponse },
  Error,
  SignInPayload
>;

type MutationMagicLogin = UseMutationOptions<
  { data: MagicLoginResponse },
  Error,
  { token: string }
>;

type MutationResetPasswordChallenge = UseMutationOptions<
  { data: ResetPasswordChallengeResponse },
  Error,
  { password: string; token: string; subdomain: string }
>;

const useSignIn = (options: MutationSignIn = {}) => {
  const mutation = useMutation({
    mutationFn: (payload: SignInPayload) => AuthService.signIn(payload),
    mutationKey: ['signIn'],
    ...options,
  });

  return mutation;
};

const useMagicLogin = (options: MutationMagicLogin = {}) => {
  const mutation = useMutation({
    mutationFn: AuthService.magicLogin,
    mutationKey: ['magicLogin'],
    ...options,
  });

  return mutation;
};

const useResetPasswordChallenge = (
  options: MutationResetPasswordChallenge = {},
) => {
  const mutation = useMutation({
    mutationFn: AuthService.resetPasswordChallenge,
    mutationKey: ['resetPasswordChallenge'],
    ...options,
  });

  return mutation;
};

export { useMagicLogin, useResetPasswordChallenge, useSignIn };
